import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () =>
  import('@/containers/DefaultContainer')

// Views
const Dashboard = () =>
  import('@/views/Dashboard')
const Login = () =>
  import('@/views/Login')

const ifAuthenticated = (to, from, next) => {
  if (localStorage.getItem("user-token")) {
    next();
    return;
  }
  next('/login');
}

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: 'form',
          component: Dashboard,
          //beforeEnter: ifAuthenticated
        },
        {
          path: 'login',
          name: 'login',
          component: Login
        }
  ]
}
]
})
